import NpapiStrategy from './npapi';
export default NpapiStrategy;
